<template>
    <AdminLayout>
        <page-header title="My Real Property Tax Accounts" subtitle="Manage and track all your real property accounts"
            :breadcrumbs="[
                { label: 'Dashboard', path: '/dashboard' },
                { label: 'Wash', path: '/rpt' }
            ]" :action="{
            label: 'Add Real Property Tax Account',
            icon: 'plus-lg',
            handler: addNewWashAccount
        }" />

        <RPTaxCard :accounts="accounts" @remove="handleRemove" @add-account="addNewWashAccount"
            @view-bills="handleViewBills" />

    </AdminLayout>
    <FullscreenModal title="Real Property Tax" :show="showModal" @close="toggleModal">
        <RPTaxBillsViewer @view-receipt="handleViewReceipt" @pay-now="handlePayNow" :billing-statement="loadedBills" />
    </FullscreenModal>
    <ChildModal :show="showChildModal" @close="toggleChildModal">
        <SearchRPTaxAccount @account-bound="getLinkedAccounts" @view-accounts="toggleChildModal" ref="searchAcctRef" />
    </ChildModal>
    <FullscreenModal2 :show="showReceiptModal" @close="toggleReceiptModal">
        <Form51Receipt />
    </FullscreenModal2>
</template>

<script setup>
import PageHeader from '@/components/commons/PageHeader.vue';
import RPTaxCard from '@/components/commons/RPTaxCard.vue';
import RPTaxBillsViewer from '@/components/infos/RPTaxBillsViewer.vue';
import SearchRPTaxAccount from '@/components/inputs/SearchRPTaxAccount.vue';
import ChildModal from '@/components/modals/ChildModal.vue';
import FullscreenModal from '@/components/modals/FullscreenModal.vue';
import FullscreenModal2 from '@/components/modals/FullscreenModal2.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import Form51Receipt from '@/receipts/Form51Receipt.vue';
import confirmationService from '@/services/confirmationService';
import paymentService from '@/services/paymentService';
import rptaxService from '@/services/rptaxService';
import spinnerService from '@/services/spinnerService';
import toastService from '@/services/toastService';
import { nextTick, onMounted, ref } from 'vue';
const accounts = ref([]);
const loadedBills = ref({ billings: [] });
const showModal = ref(false);
const showChildModal = ref(false);
const toggleModal = () => {
    showModal.value = !showModal.value;
}
const addNewWashAccount = () => {
    toggleChildModal();
    nextTick(() => {
        searchAcctRef.value?.resetSearch();
    })
}

const handleViewReceipt = () => {
    toggleReceiptModal();
}

const showReceiptModal = ref(false);
const toggleReceiptModal = () => {
    showReceiptModal.value = !showReceiptModal.value;
}

const toggleChildModal = () => {
    showChildModal.value = !showChildModal.value;
}

const searchAcctRef = ref(null);



const handleRemove = async (account) => {
    const confirmed = await confirmationService.show(`Are you sure you want to remove this account: ${account.account_name}?`);
    if (!confirmed) return;
    spinnerService.show();
    const resp = await rptaxService.removeAccount(account.account);
    if (resp.success) {
        toastService.success("Account removed successfully!")
        getLinkedAccounts();
    }
    else {
        toastService.error(resp.message);
    }
    spinnerService.hide();
}

const getLinkedAccounts = async () => {
    spinnerService.show();
    accounts.value = await rptaxService.getLinkedAccounts();
    spinnerService.hide();
}
const selectedAccount = ref({})
const handleViewBills = async (account) => {
    selectedAccount.value = account;
    spinnerService.show();
    toggleModal();
    loadedBills.value = await rptaxService.getBllingStatement(account.external_key)
    spinnerService.hide();

}

const handlePayNow = async (data) => {
    const payload = {
        amount: data.amount,
        item_id: selectedAccount.value.external_key,
        account_no: selectedAccount.value.account,
        account_name: selectedAccount.value.account_name
    }
    spinnerService.show();
    const resp = await paymentService.initiateRPTPayment(payload);
    if (resp.success) {
        window.location.href = resp.url;
    }
    else {
        toastService.error(resp.message);
        spinnerService.hide();
    }
}

onMounted(() => {
    getLinkedAccounts();
});

</script>